module.exports = "<page-header class=\"page-header\"></page-header>\n<main ui-view class=\"main\" role=\"main\"></main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/engineer.html
// module id = 311
// module chunks = 0